import { useUser } from "@/context/useUser";
import { getAccessToken } from "@/lib/storeManager";
import { Navigate, Outlet } from "react-router-dom";
import IPOUserNavigationRoutes from "../../utils/navigationRoutes";

const IPOProtectedRouter = () => {
  const { isAuthenticated } = useUser();
  const isLoggedIn = getAccessToken() !== null;

  return isAuthenticated || isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to={IPOUserNavigationRoutes.IPO_HOME} />
  );
};

export default IPOProtectedRouter;
